import { render, staticRenderFns } from "./NavigationStatistics.vue?vue&type=template&id=3c38e19c"
import script from "./NavigationStatistics.vue?vue&type=script&lang=js"
export * from "./NavigationStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports